// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"197":"33de8dec","693":"9f6ef733","827":"75267b29"}[chunkId] + ".css";
};